import React from 'react';
import { allFeatures } from './featureData';
import { FeatureCard } from './FeatureCard';
import { MarketingReveal } from '@/src/modules/components/marketing/MarketingReveal';

export const EndlessWaysSection: React.FC = () => {
  return (
    <section data-section="endless-ways" className="py-24 bg-surface relative overflow-hidden">
      {/* Background ambient light */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] rounded-full bg-primary/5 blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <MarketingReveal>
            <span className="inline-block py-1 px-3 rounded-full bg-primary/10 text-primary font-bold text-xs mb-6 uppercase tracking-wider">
              Beyond Invitations
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-on-surface mb-6 tracking-tight">
              Unending Ways to Share Joy
            </h2>
            <p className="text-xl text-on-surface-variant leading-relaxed">
              Make your events unforgettable for everyone around you.
            </p>
          </MarketingReveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {allFeatures.map((feature, index) => (
            <FeatureCard key={feature.id} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};
